'use strict';

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance"); }

function _iterableToArray(iter) { if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } }

module.exports = function (darc) {
  var WriteOp = require('./../WriteOp');

  darc.addOperation({
    name: 'splice',
    args: [],
    description: '',
    inputs: 'T[]',
    extends: WriteOp,
    bubble: {
      update: function update(msg, element) {
        msg.deltas = {
          $splice: this.$.args
        };
      }
    },
    process: {
      update: function update(element, args) {
        element.splice.apply(element, _toConsumableArray(args));
        return element;
      }
    }
  });
};
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uL3NvdXJjZS9vcHMvc3BsaWNlLmpzIl0sIm5hbWVzIjpbIm1vZHVsZSIsImV4cG9ydHMiLCJkYXJjIiwiV3JpdGVPcCIsInJlcXVpcmUiLCJhZGRPcGVyYXRpb24iLCJuYW1lIiwiYXJncyIsImRlc2NyaXB0aW9uIiwiaW5wdXRzIiwiZXh0ZW5kcyIsImJ1YmJsZSIsInVwZGF0ZSIsIm1zZyIsImVsZW1lbnQiLCJkZWx0YXMiLCIkc3BsaWNlIiwiJCIsInByb2Nlc3MiLCJzcGxpY2UiXSwibWFwcGluZ3MiOiJBQUFBOzs7Ozs7Ozs7O0FBRUFBLE9BQU9DLE9BQVAsR0FBaUIsVUFBVUMsSUFBVixFQUFpQjtBQUVqQyxNQUFNQyxVQUFVQyxRQUFTLGNBQVQsQ0FBaEI7O0FBRUFGLE9BQUtHLFlBQUwsQ0FBbUI7QUFFbEJDLFVBQU0sUUFGWTtBQUdsQkMsVUFBTSxFQUhZO0FBSWxCQyxpQkFBYSxFQUpLO0FBS2xCQyxZQUFRLEtBTFU7QUFNbEJDLGFBQVNQLE9BTlM7QUFRbEJRLFlBQVE7QUFFUEMsY0FBUSxnQkFBVUMsR0FBVixFQUFlQyxPQUFmLEVBQXlCO0FBRWhDRCxZQUFJRSxNQUFKLEdBQWE7QUFDWkMsbUJBQVMsS0FBS0MsQ0FBTCxDQUFPVjtBQURKLFNBQWI7QUFJQTtBQVJNLEtBUlU7QUFvQmxCVyxhQUFTO0FBRVJOLGNBQVEsZ0JBQVVFLE9BQVYsRUFBbUJQLElBQW5CLEVBQTBCO0FBRWpDTyxnQkFBUUssTUFBUixtQ0FBbUJaLElBQW5CO0FBQ0EsZUFBT08sT0FBUDtBQUVBO0FBUE87QUFwQlMsR0FBbkI7QUFpQ0EsQ0FyQ0QiLCJzb3VyY2VzQ29udGVudCI6WyIndXNlIHN0cmljdCc7XG5cbm1vZHVsZS5leHBvcnRzID0gZnVuY3Rpb24oIGRhcmMgKSB7XG5cblx0Y29uc3QgV3JpdGVPcCA9IHJlcXVpcmUoICcuLy4uL1dyaXRlT3AnICk7XG5cblx0ZGFyYy5hZGRPcGVyYXRpb24oIHtcblxuXHRcdG5hbWU6ICdzcGxpY2UnLFxuXHRcdGFyZ3M6IFtdLFxuXHRcdGRlc2NyaXB0aW9uOiAnJyxcblx0XHRpbnB1dHM6ICdUW10nLFxuXHRcdGV4dGVuZHM6IFdyaXRlT3AsXG5cblx0XHRidWJibGU6IHtcblxuXHRcdFx0dXBkYXRlOiBmdW5jdGlvbiggbXNnLCBlbGVtZW50ICkge1xuXG5cdFx0XHRcdG1zZy5kZWx0YXMgPSB7XG5cdFx0XHRcdFx0JHNwbGljZTogdGhpcy4kLmFyZ3Ncblx0XHRcdFx0fTtcblxuXHRcdFx0fVxuXG5cdFx0fSxcblxuXHRcdHByb2Nlc3M6IHtcblxuXHRcdFx0dXBkYXRlOiBmdW5jdGlvbiggZWxlbWVudCwgYXJncyApIHtcblxuXHRcdFx0XHRlbGVtZW50LnNwbGljZSggLi4uYXJncyApO1xuXHRcdFx0XHRyZXR1cm4gZWxlbWVudDtcblxuXHRcdFx0fVxuXG5cdFx0fVxuXG5cdH0gKTtcblxufTtcbiJdfQ==